// extracted by mini-css-extract-plugin
module.exports = {"privacy":"Privacy_privacy__3bH6U","content":"Privacy_content__3-zUr"};